export enum CampagneProjection {
  DEFAULT = 'DEFAULT',
  LIGHT = 'LIGHT',
  ANNEE = 'ANNEE',
}